import React from 'react';
import './Header.scss';

const Header = () => (
  <header className="header">
    <div className="content">
      <div className="content__personal-info">
        <p className="content__personal-info_name">Klimm Ivan</p>
        <p className="content__personal-info_specialization">Front-end developer</p>
      </div>
    </div>
  </header>
);

export default Header;
